// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__2z9AP"};